import { BifrostBackendNestApi, BifrostBackendViaCdnApiV2 } from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";

const UpsellRulesProvider = {
	async findAll(queryData = {}, useApiCdnCaching) {
		const res = await (useApiCdnCaching ? BifrostBackendViaCdnApiV2 : BifrostBackendNestApi).get("/upsale-rules", {
			params: {
				"$limit": "10000",
				...queryData,
				tenantId: appConfig.tenantId
			}
		});

		return res.data;
	},

	async insert(data, jwtToken) {
		data.tenantId = appConfig.tenantId;
		return BifrostBackendNestApi.post("/upsale-rules", data, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async delete(id, jwtToken) {
		return BifrostBackendNestApi.delete(`/upsale-rules/${id}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async get(id, jwtToken) {
		return BifrostBackendNestApi.get(`/upsale-rules/${id}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async update(id, data, jwtToken) {
		return BifrostBackendNestApi.patch(`/upsale-rules/${id}?tenantId=${data.tenantId}`, data, {
			headers: {
				Authorization: jwtToken
			}
		});
	},

	async getUpsellList(queryData = {}) {
		const res = await BifrostBackendNestApi.get("/upsale-rules/results/upsell", {
			params: {
				...queryData,
				tenantId: appConfig.tenantId
			}
		});

		return res.data;
	}
};

export default Object.freeze(UpsellRulesProvider);
